<script setup>
import ToastDismissAll from '~/components/common/ToastDismissAll.vue'
import NewReleaseNotice from '~/components/app/NewReleaseNotice.vue'

// max=20: prevents a runaway loop of error toasts from flooding the UI.
// New toasts past the cap evict the oldest. duration is overridden per-toast
// in useNotifications.ts (success/info/warning: 10s, error: sticky).
//
// Top right, under the header bar (Mark, 2026-10-22): at the bottom right they sat on a window's
// Close and Save, and on the tablet a tap meant for Close hit the message. The stack starts under
// the ToastDismissAll pill, which sits just under the header bar.
const toaster = {
  max: 20,
  position: 'top-right',
  ui: { viewport: 'top-[7.5rem]' }
}
</script>

<template>
  <UApp :toaster="toaster">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ToastDismissAll />
    <NewReleaseNotice />
  </UApp>
</template>
